import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { Container, Divider, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import TwoFacIcon from "../../../assets/2fac-faq.png";
import TradeIcon from "../../../assets/trade.png";
import HarvestIcon from "../../../assets/harvest.png";
import DepositIcon from "../../../assets/deposit.png";
import IntroFriendsIcon from "../../../assets/intro-friends.png";
import UserRegisterIcon from "../../../assets/user-check-1.png";
import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import FaqIcon from "../../../assets/message-icon-faq.png";
import MinimizeIcon from "@mui/icons-material/Minimize";
import AddIcon from "@mui/icons-material/Add";

const Tab = styled(TabUnstyled)`
  background-color: inherit;
  padding: 20px 15px;
  border: 0px;
  display: flex;
  justify-content: start;
  flex-direction: column;
  border-radius: 10px;
  width: 100%;
  height: 16rem;
  border: none;

  &:hover {
    background-color: inherit;
  }

  &:focus {
    color: #fff;
  }

  &.${tabUnstyledClasses.selected} {
    border: none;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
    border: none;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)(
  ({ theme }) => `
    width: 100%;
    margin-top:2rem;
    background-color: background.darkBlue;
    border-radius: 10px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;  

    `
);

export function ControlledAccordions() {
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Grid container sx={{ justifyContent: "center", mt: 8, mb: 4 }}>
      <Grid item xs={12} md={12}>
        <Accordion
          disableGutters
          sx={{
            borderRadius: "10px !important",
            p: 1,
            my: 2,
            bgcolor: "background.darkBlack",
          }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel1" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            sx={{ borderRadius: "10px" }}
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel2" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel3" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel4" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel5" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel6"}
          onChange={handleChange("panel6")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel6" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel7"}
          onChange={handleChange("panel7")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel7" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          disableGutters
          sx={[
            {
              borderRadius: "10px",
              p: 1,
              my: 2,
              bgcolor: "background.darkBlack",
            },
            { "&::before": { height: 0 } },
          ]}
          expanded={expanded === "panel8"}
          onChange={handleChange("panel8")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "panel8" ? (
                <MinimizeIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              ) : (
                <AddIcon sx={{ color: "#8E2DE2", fontSize: "large" }} />
              )
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>{t("exchange_crypto")}</Typography>
          </AccordionSummary>
          <Divider
            sx={{ borderColor: "text.primary", borderBottomWidth: "1px" }}
          />
          <AccordionDetails>
            <Typography variant="body2">
              {t("exchange_crypto_paragraph")}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
}

export default function AccardionFaq() {
  const { t } = useTranslation();

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ mx: 0, px: 0, bgcolor: "inherit" }}>
      <Container sx={{ px: { xs: 0 } }}>
        <Box sx={{ pb: 3, pt: 0 }}>
          <TabsUnstyled defaultValue={0}>
            <TabsList>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Tab value={0}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                    >
                      من در سایت ثبت نام کردم چه موقع حساب من فعال خواهد شد؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      پس از ثبت نام با شما تماس تلفنی گرفته می شود و سپس حساب
                      شما فعال می شود. پس از فعال شدن حساب کاربری امکان لاگین در
                      سایت را خواهید داشت. در صورت تایید نشدن حساب کاربری، برای
                      شما ایمیل ارسال خواهد شد. ایمیل خودتان را چک کنید. در صورت
                      نیاز می توانید مجدد ثبت نام نمایید. تایید حساب کاربری صرفا
                      از طریق تماس با تلفن ثابت انجام می شود.
                    </Typography>
                  </Tab>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Tab value={1}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                    >
                      روش خرید پولهای الکترونیک به چه صورت است؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      برای خرید پولهای الکترونیک، مراحل بخش خرید را تکمیل
                      نمایید. خرید با استفاده از رمز دوم کارت بانکی و پرداخت در
                      درگاه بانک انجام می شود. امکان خرید از تمام کارتهای شبکه
                      بانکی شتاب وجود دارد. برای خرید پولهای الکترونیک باید در
                      سایت عضو باشید و حساب کاربری شما بررسی و تایید شده باشد.
                    </Typography>
                  </Tab>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Tab value={2}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                      textAlign={"left"}
                    >
                      پس از خرید بیت کوین یا وبمانی یا پرفکت مانی، چه زمانی پول
                      الکترونیک به حساب من واریز می شود؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      خرید از کارتهای بانکی تایید شده شما در تمام ساعات شبانه
                      روز، خودکار و لحظه ای انجام می شود.
                    </Typography>
                  </Tab>
                </Grid>

                <Grid item xs={12} md={4}>
                  <Tab value={3}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                    >
                      چه مقدار طول می کشد تا کارت بانکی من تایید شود؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      تایید کارت بانکی معمولا طی 5 دقیقه انجام می شود. ولی در
                      موارد نادری که هیچ یک از پشتیبانهای سایت آنلاین نباشند،
                      باید تا آنلاین شدن یک پشتیبان منتظر بمانید.
                    </Typography>
                  </Tab>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Tab value={4}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                    >
                      سقف خرید روزانه چگونه افزایش می یابد؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      سقف خرید روزانه، در ابتدای عضویت در سایت،یک و نیم میلیون
                      تومان در روز است. سقف خرید روزانه به تدریج و بسته به خرید
                      و فروشهای شما افزایش می یابد. همچنین می توانید 2 یا 3 یا
                      تعداد بیشتری از کارتهای بانکی به نام خودتان را در بخش خرید
                      با کلیک روی گزینه “ثبت کارت جدید”، ثبت نمایید تا سقف
                      خریدتان به 2 برابر یا 3 برابر یا بیشتر افزایش یابد. ثبت
                      کارت صرفا برای افزایش سقف روزانه است و تمام خرید خودتان را
                      می توانید فقط از یک کارت انجام دهید. جهت افزایش بیشتر سقف
                      خرید روزانه می توانید با تعیین وقت قبلی به صورت حضوری
                      مراجعه نمایید.
                    </Typography>
                  </Tab>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Tab value={5}>
                    <Box
                      bgcolor={"#ff3dff"}
                      p={1}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={1}
                      mb={2}
                    >
                      <img src={FaqIcon} alt="icon image" width="100%" />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      color="text.title"
                      textAlign={"left"}
                    >
                      واریز مبلغ فروش وبمانی و پرفکت مانی و کد وکس چه مقدار طول
                      می کشد؟
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      component="span"
                      color="text.secondary"
                      sx={{ textAlign: "justify", mt: 1 }}
                    >
                      حداکثر یک روز کاری پس از تکمیل فروش، مبلغ به حساب شما
                      واریز می شود.
                    </Typography>
                  </Tab>
                </Grid>
              </Grid>
            </TabsList>
          </TabsUnstyled>
        </Box>
      </Container>
    </Box>
  );
}
